// extracted by mini-css-extract-plugin
export default {"wrap":"TocHeader_wrap__swGCO"};